import { useContext } from 'react';
import { ToastContextProviderType, ToastContext } from '../../components/GlobalToaster/GlobalToastProvider';

export const useToast = (): ToastContextProviderType => useContext(ToastContext);
